module.exports = __webpack_public_path__ + "img/hr-light-mud-decal-21.7d21b2ea.png";